// extracted by mini-css-extract-plugin
module.exports = {"slideWrapper":"tA","imageWrapper":"tB","image":"tC","imageInCenter":"tD","ctaWrapper":"tE","copyright":"tF","rentalBadge":"tG","sideGradient":"tH","bottomGradient":"tI"};